//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { FaSpinner } from 'react-icons/fa';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
export const ButtonStyle = {
  Secondary: 'Secondary',
  Custom: 'Custom',
  Primary: 'Primary',
  Link: 'Link',
  Outlined: 'Outlined',
  Filled: 'Filled',
  GenBtn: 'GenBtn',
};
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Button extends React.Component {
  constructor(props) {
    super(props);
  }

  eventHandler(e, disabled, loading, onClick, history, to) {
    let handlerFn = () => {}; // noop
    const enterKeyPressedOrClicked = e.type === 'click' || e.key === 'Enter';
    if (!disabled && !loading && enterKeyPressedOrClicked) {
      if (onClick) {
        handlerFn = onClick;
      } else if (to) {
        handlerFn = () => history.push(to);
      }
    }
    handlerFn();
  }
  render() {
    const {
      className,
      children,
      history,
      disabled,
      loading,
      to,
      onClick,
      iconComponent,
      disableTabIndex,
    } = this.props;
    let styleKey = this.props.style;
    if (styleKey !== 'Filled' && styleKey !== 'Outlined') {
      styleKey = ButtonStyle.Primary;
    }

    const componentClasses = classNames(styles.Button, {
      [className]: className,
      [styles[styleKey]]: styleKey,
      [styles.Disabled]: disabled,
    });

    const linkClasses = classNames({
      [styles.leftMargin]: iconComponent,
    });

    return (
      <div
        className={componentClasses}
        tabIndex={disableTabIndex ? -1 : 0}
        onClick={(e) =>
          this.eventHandler(e, disabled, loading, onClick, history, to)
        }
        onKeyDown={(e) =>
          this.eventHandler(e, disabled, loading, onClick, history, to)
        }
      >
        {loading ? (
          <FaSpinner className={styles.Icon} />
        ) : (
          <>
            {iconComponent}
            <span className={linkClasses}>{children}</span>
          </>
        )}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withRouter(Button);
